export default __webpack_public_path__ + "static/media/coib-nou-logo-verd.4e9d3e03.png";